export default __webpack_public_path__ + "static/media/Bukidnon.af780330.png";